import { useQuery } from "@tanstack/react-query";
import { API } from "config";

const useActiveConsultantsCount = () =>
    useQuery({
        queryKey: ["consultants-active-count"],
        queryFn: async () => {
            const { data } = await API.get("/consultants/count-active");
            return data;
        },
        staleTime: 5 * 60 * 1000,      // 5 min — dado do mês corrente muda com frequência
        refetchOnWindowFocus: false,
    });

export default useActiveConsultantsCount;
